import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { User } from '@/types'
import { AndroidLogo } from 'phosphor-react'

export function createApkColumn(onApkClick: (user: User) => void): ColDef {
  return {
    colId: 'apk',
    headerName: 'APK',
    width: 90,
    minWidth: 90,
    sortable: false,
    filter: false,
    cellRenderer: (params: ICellRendererParams<User>) => {
      if (!params.data) return null

      return (
        <button
          type="button"
          onClick={() => onApkClick(params.data!)}
          className="inline-flex items-center justify-center w-8 h-8 rounded-lg text-[var(--color-primary)] hover:bg-[var(--color-gray-100)] transition-colors"
          title="Gérer l'APK"
          aria-label="Gérer l'APK"
        >
          <AndroidLogo className="w-5 h-5" weight="regular" />
        </button>
      )
    },
  }
}
